<template>
  <div class="main-content">
    <div>
      <b-row>
        <b-col md="8">
          <h2 class="page-title">
            Clients
            <!-- <small v-if="userIsAdmin" class="add-new">
              <a v-b-modal.modal-add-project>
                <i class="nav-icon i-Add"></i>
                <span class="item-name"> Add New</span>
              </a>
            </small> -->
            <b-dropdown size="sm" variant="outline-primary" :text="state">
              <b-dropdown-item @click="changeState('All')">
                Show All
              </b-dropdown-item>
              <b-dropdown-item @click="changeState('Active')">
                Show Active
              </b-dropdown-item>
              <b-dropdown-item @click="changeState('Tickets')">
                Show Just Tickets
              </b-dropdown-item>
              <b-dropdown-item @click="changeState('Tasks')">
                Show Just Tasks
              </b-dropdown-item>
              <b-dropdown-item @click="changeState('Over')">
                Show <strong>Over</strong> Allocation
              </b-dropdown-item>
              <b-dropdown-item @click="changeState('Under')">
                Show <strong>Under</strong> Allocation
              </b-dropdown-item>
            </b-dropdown>
          </h2>
        </b-col>
        <b-col md="4">
          <b-form-input
            v-model="searchWord"
            class="form-control-rounded"
            type="text"
            required
            placeholder="Search..."
          ></b-form-input>
        </b-col>
      </b-row>
      <b-row v-if="loading">
        <b-col md="4">
          <loadingSkeleton />
        </b-col>
        <b-col md="4">
          <loadingSkeleton />
        </b-col>
        <b-col md="4">
          <loadingSkeleton />
        </b-col>
      </b-row>
      <div v-show="!loading" v-if="constrcuting">
        <transition-group name="fade" tag="b-row">
          <b-col
            v-for="client in filteredClients"
            :key="client.id"
            md="6"
            lg="4"
          >
            <projectBlock :client="client" @colour-changed="updateColour" />
          </b-col>
        </transition-group>
      </div>
      <!-- <b-modal
        v-if="userIsAdmin"
        id="modal-add-project"
        centered
        :hide-footer="true"
        :hide-header="true"
        size="lg"
      >
        <div class="modal-addition-only">
          <b-form-input
            v-model="newProjectName"
            class="form-control-rounded input-extra-large"
            type="text"
            required
            placeholder="Enter project name..."
            @keyup.enter="addProject()"
          ></b-form-input>

          <b-form-select
            v-model="client"
            :options="clients.map(x => x.name)"
            class="mb-3 select-custom"
          >
            <template v-slot:first>
              <option :value="null" disabled
                >-- Please select a Client --</option
              >
            </template>
          </b-form-select>
          <b-button pill variant="success ripple col-md-2" @click="addProject()"
            >Save</b-button
          >
        </div>
      </b-modal> -->
    </div>
  </div>
</template>
<script>
import Util from "@/utils"
import projectBlock from "@/components/projectblock"
import loadingSkeleton from "@/components/projectblock/loadSkeleton"
import { mapState, mapActions } from "vuex"

export default {
  layout: "default",
  name: "Type",
  components: {
    projectBlock,
    loadingSkeleton
  },
  apollo: {
    clients: {
      query: require("@/graphql/Client/GetClients.gql"),
      update(data) {
        setTimeout(() => {
          this.constrcuting = true
          this.$nextTick(() => {
            this.loading = false
          })
        }, 500)
        return data.clients
      },
      fetchPolicy: "no-cache"
    }
  },
  data() {
    return {
      projectType: "",
      newProjectName: "",
      searchWord: "",
      loading: true,
      constrcuting: false,
      showAll: false,
      showJustTickets: false,
      state: "Active"
    }
  },
  computed: {
    ...mapState({
      currentUser: state => state.users.currentUser
    }),
    filteredClients() {
      let filteredClients = this.clients?.filter(
        x =>
          x.name?.includesLowerCase(this.searchWord) &&
          //If the user is searching show everything
          (this.searchWord ||
            //If user has selected 'all' - show all
            this.state === "All" ||
            //If user has selected 'Active' - show Active
            (this.state === "Active" &&
              (x.incompleteTickets || x.incompleteTasks)) ||
            //If user has selected 'Tickets' - show Tickets
            (this.state === "Tickets" && x.incompleteTickets) ||
            //If user has selected 'Tasks' - show Tasks
            (this.state === "Tasks" && x.incompleteTasks) ||
            (this.state === "Over" &&
              x.supportTime &&
              this.getRemainingHours(x) < 0) ||
            (this.state === "Under" &&
              x.supportTime &&
              this.getRemainingHours(x) > 0))
      )
      //If the state is Over sort by largest remaining
      if (this.state === "Over")
        return filteredClients.sort((a, b) => a.remaining - b.remaining)
      //If the state is Under sort by lowest remaining ('largest' negative first)
      if (this.state === "Under")
        return filteredClients.sort((a, b) => b.remaining - a.remaining)

      return filteredClients.sortBy(x => x.name)
    },
    projectDescription() {
      return `A slack channel for communication regarding the ${this.projectType.substring(
        0,
        this.projectType.length - 1
      )}: ${Util.linkToString(this.newProjectName)}`
    },
    userIsAdmin() {
      return (
        this.currentUser &&
        this.currentUser.roles &&
        (this.currentUser.roles.includes("Admin") ||
          this.currentUser.roles.includes("Super Admin"))
      )
    }
  },
  methods: {
    ...mapActions({
      linkProjectsToClient: "projects/linkProjectsToClient"
    }),
    /**
     * Gets the remaining Billable hours for client
     * @param client
     * @returns {number}
     */
    getRemainingHours(client) {
      let total = 0
      if (!client.timeLogs?.some(x => x)) total = client.supportTime
      else
        client.timeLogs.forEach(c => {
          total +=
            (c.type === "Billable" || c.type === "Unsure") && c.support
              ? c.time
              : 0 || 0
        })

      total = client.supportTime - total
      total = parseFloat(total.toFixed(2))
      client.remaining = total
      return total
    },
    getOtherHours(client) {
      let total = 0
      if (!client.timeLogs?.some(x => x)) return total
      else
        client.timeLogs.forEach(c => {
          total += (!c.support ? c.time : 0) || 0
        })

      return parseFloat(total.toFixed(2))
    },
    /**
     *
     * @param state
     */
    changeState(state) {
      this.state = state
    },
    /**
     * Adds the new project
     * @returns {Promise<ToastObject>}
     */
    async addProject() {
      if (!this.newProjectName) {
        return this.$toasted.error("Please enter a project name.")
      }
      if (!this.client)
        return this.$toasted.error("Pleaseselect a client for this project.")
      if (
        this.projects.filter(
          project => project.name == Util.linkToString(this.newProjectName)
        ).length > 0
      ) {
        return this.$toasted.error("A project with this name already exists")
      }
      //Adding Slack channel for this project with an appropriate description and saving
      //..the channel Id to the project
      else
        new Promise(() => {
          this.$slack
            .addProjectChannel(
              Util.linkToString(this.newProjectName),
              this.projectDescription
            )
            .then(id => {
              this.$store.state.db
                .collection("projects")
                .add({
                  name: Util.linkToString(this.newProjectName),
                  lists: [
                    {
                      name: "Milestone 1",
                      identifier: Util.generateGuid(),
                      archived: false,
                      tasks: []
                    }
                  ],
                  type: this.projectType.toLowerCase(),
                  channelId: id,
                  colour: "#73d8ff",
                  next_task_number: 1
                })
                .then(async addedProject => {
                  await this.linkProjectsToClient({
                    projects: [addedProject],
                    clientId: this.clients.find(x => x.name === this.client).id
                  })
                  this.$toasted.success(
                    `${Util.linkToString(
                      this.newProjectName
                    )} has been added as a project`
                  )
                  this.newProjectName = ""
                })
            })
            .catch(error => {
              this.$toasted.error(
                `There was an issue adding this project: ${error}`
              )
            })
        })

      this.$bvModal.hide("modal-add-project")
    },
    /**
     * updates client's colour
     * @param client
     * @returns {Promise<void>}
     */
    async updateColour(client) {
      await this.$apollo.mutate({
        mutation: require("@/graphql/Client/UpdateClient.gql"),
        variables: {
          client: {
            name: client.name,
            id: client.id,
            colour: client.colour
          }
        }
      })
    },
    toLink(projectName) {
      return Util.stringToLink(projectName)
    }
  }
}
</script>
<style scoped>
.button-container {
  text-align: right;
}
.modal-addition-only {
  display: flex;
  flex-direction: column;
}
.modal-addition-only input {
  margin-right: 15px;
}
.add-new:hover {
  cursor: pointer;
}
.select-custom {
  margin-top: 1rem;
}
</style>
